import Api from "../../service";
import REQUEST_URLS from "../../defaults/requestUrl";

async function createProcess(token,params){
    return Api.post(REQUEST_URLS.FIN_CHECK.CREATE_PROCESS,params,{
        headers:{
            'Authorization': 'Bearer ' + token
        }
    })
}
export default createProcess;